import dva from 'dva';
import { Component } from 'react';
import createLoading from 'dva-loading';
import history from '@tmp/history';

let app = null;

export function _onCreate() {
  const plugins = require('umi/_runtimePlugin');
  const runtimeDva = plugins.mergeConfig('dva');
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    ...(window.g_useSSR ? { initialState: window.g_initialData } : {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach(plugin => {
    app.use(plugin);
  });
  
  app.model({ namespace: 'acts', ...(require('/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/models/acts.js').default) });
app.model({ namespace: 'deviceOp', ...(require('/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/models/deviceOp.js').default) });
app.model({ namespace: 'user', ...(require('/usr/local/agent/workspace/p-49ab9dcdea424f8ba8390fd25a42df0d/src/h5-box.onethingpcs.com/src/models/user.js').default) });
  return app;
}

export function getApp() {
  return app;
}

export class _DvaContainer extends Component {
  render() {
    const app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
